"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getPausedTime = () => {
    let time = 0;
    state_1.default.pauses.forEach((pause) => {
        if (pause.unpausedAt === null) {
            time += state_1.default.currentTime - pause.pausedAt;
        }
        else {
            time += pause.unpausedAt - pause.pausedAt;
        }
    });
    return time;
};
exports.default = getPausedTime;
